const fields = ['bold', 'italic', 'underline', 'lineThrough'] as const;

export type FontStyleValues = Record<(typeof fields)[number], boolean>;

type FontStyleSource = FontStyleValues & {
    textContents?: (Partial<FontStyleValues> & { text?: string })[];
};

type FontStyleRangeState = { type: 'none' } | { type: 'uniform' | 'mixed'; attrs: Partial<FontStyleValues> };

export const resolveFontStyleValues = (
    data: FontStyleSource | null,
    rangeState: FontStyleRangeState | null,
): FontStyleValues => {
    const rangeAttrs = rangeState?.type === 'uniform' || rangeState?.type === 'mixed' ? rangeState.attrs : null;

    return Object.fromEntries(
        fields.map((field) => {
            // 编辑态优先使用选区；非编辑态则聚合 textContents，并让未声明的 span 继承图层默认值。
            if (rangeAttrs) return [field, rangeAttrs[field] ?? false];

            const fallback = data?.[field] ?? false;
            if (rangeState?.type === 'none' || !data?.textContents?.length) return [field, fallback];

            const value = data.textContents[0][field] ?? fallback;
            const isUniform = data.textContents.every((item) => (item[field] ?? fallback) === value);
            return [field, isUniform ? value : false];
        }),
    ) as FontStyleValues;
};
